import { Box, Button, Dialog, Flex, Kbd, Text, TextArea, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { FormField } from 'shared/components';
import { toast } from 'sonner';
import { SendEmailStore } from './SendEmailStore';

function SendEmailViewFn({
   store,
   candidateId,
   slug,
   candidateName,
}: {
   store: SendEmailStore;
   candidateId: number;
   slug: string;
   candidateName?: string;
}) {
   return (
      <Dialog.Root
         open={store.showDialog}
         onOpenChange={(o) => {
            store.toggleDialog(o);
            if (!o) {
               store.form.reset();
            }
         }}
      >
         <Dialog.Trigger>
            <Button size="4"> Надіслати лист </Button>
         </Dialog.Trigger>

         <Dialog.Content size="2">
            <form
               className="send-email-applicants"
               onSubmit={(e) => {
                  e.preventDefault();
                  store.sendEmail(
                     'single',
                     { slug, candidateId },
                     {
                        onSuccess: (res) => {
                           console.log(res);
                           toast.success('Електронний лист успішно надіслано!');
                        },
                        onError: (e) => {
                           toast.error(
                              'Не вдалося відправити електронний лист, спробуйте пізніше',
                              {
                                 position: 'top-center',
                              }
                           );
                        },
                     }
                  );
               }}
            >
               <Flex py="2" px="3" style={{ background: 'var(--blue-11)', color: 'white' }}>
                  <span>Надіслати лист</span>
               </Flex>

               <Box mt="1" mb="4">
                  <Text color="gray" size="2">
                     Кому:
                  </Text>
                  <Flex pb="2" pt="1" direction="column" gap="2">
                     <Kbd>{candidateName}</Kbd>
                  </Flex>
               </Box>

               <Flex direction="column" gap="4">
                  <FormField label="Тема" error={store.form.controls['subject'].error}>
                     <TextField.Root
                        placeholder="Тема"
                        size="3"
                        color="blue"
                        value={store.form.controls['subject'].value}
                        onChange={(e) => {
                           store.form.controls['subject'].setValue(e.target.value);
                        }}
                     ></TextField.Root>
                  </FormField>

                  <FormField label="Повідомлення" error={store.form.controls['message'].error}>
                     <TextArea
                        placeholder="Повідомлення"
                        size="3"
                        color="blue"
                        value={store.form.controls['message'].value}
                        onChange={(e) => {
                           store.form.controls['message'].setValue(e.target.value);
                        }}
                     ></TextArea>
                  </FormField>
               </Flex>

               <Flex justify="end" gap="3" mt="4">
                  <Button color="red" size="3" type="submit" loading={store.emailSending}>
                     Надіслати
                  </Button>

                  <Dialog.Close>
                     <Button color="blue" size="3" variant="outline" highContrast>
                        Скасувати
                     </Button>
                  </Dialog.Close>
               </Flex>
            </form>
         </Dialog.Content>
      </Dialog.Root>
   );
}

export const SendEmailView = observer(SendEmailViewFn);
